<template>
  <el-form ref="formRef" :model="formModel" label-width="80px" :rules="rules">
    <el-form-item label="游戏组" prop="gameGroupId">
      <el-select :disabled="isUpdate" style="width: 100%" filterable v-model="formModel.gameGroupId" placeholder="请选择游戏组">
        <el-option v-for="group in gameGroups" :key="group.id" :label="group.name" :value="group.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="平台" prop="platform">
      <el-select :disabled="isUpdate" style="width: 100%" v-model="formModel.platform" placeholder="请选择平台">
        <el-option v-for="platform in PLATFORM_LIST" :key="platform.value" :label="platform.label" :value="platform.value"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="媒体" prop="mediaId">
      <el-select :disabled="isUpdate" style="width: 100%" filterable v-model="formModel.mediaId" placeholder="请选择媒体">
        <el-option v-for="media in medias" :key="media.mediaId" :label="media.mediaName" :value="media.mediaId"></el-option>
      </el-select>
    </el-form-item>

    <div class="rules-list">
      <el-form-item
        v-for="(rule, index) in formModel.ruleCondition"
        :key="index"
        :label="index === 0 ? '规则条件' : ''"
        :prop="'ruleCondition.' + index"
        :rules="{
          required: true,
          validator: validateRules
        }"
      >
        <div class="rule-row">
          <div class="index-text">{{ index + 1 }}</div>
          <el-select class="selector" v-model="rule.key" placeholder="规则值">
            <el-option v-for="rule in ruleKeys" :key="rule.key" :label="rule.name" :value="rule.key"></el-option>
          </el-select>

          <el-select class="selector" v-model="rule.operator" placeholder="选择操作符">
            <el-option v-for="op in operatorData" :key="op.value" :label="op.label" :value="op.value"></el-option>
          </el-select>

          <el-input class="input" v-model="rule.value" placeholder="请输入值，数值最多保留2位小数"></el-input>
          <span>{{ rule.key && ruleKeys.find((item) => item.key === rule.key).unit }}</span>
          <span v-if="formModel.ruleCondition.length > 1" @click="onFormRuleRemove(index)" class="close el-icon-circle-close"></span>
        </div>
      </el-form-item>
    </div>

    <el-form-item label="">
      <el-button v-if="ruleCounts < 10" type="text" @click="onFormRuleAdd">新增条件+</el-button>
      <span style="font-size: 12px">（{{ ruleCounts }}/10）</span>
    </el-form-item>

    <el-form-item label="数据范围">
      <el-button type="primary">今日实时</el-button>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { computed, ref, nextTick } from 'vue'
import { PLATFORM_LIST } from '@/common/js/constants'
import { initPageData, GAME_GROUPS, MEDIAS } from '@/data/global-opts'
import rules, { validateRules } from './formRule.js'
import { operatorData, ruleKeys } from './formConstData.js'
const getConditionFields = () => {
  return {
    key: '',
    operator: '>',
    value: ''
  }
}
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, MEDIAS])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const medias = computed(PAGE_REQUIRED_OPTS.MEDIAS)
const formRef = ref(null)
const formModel = ref({
  gameGroupId: '',
  platform: '',
  mediaId: '',
  ruleCondition: [getConditionFields()],
  dataRange: 1
})

const ruleCounts = computed(() => formModel.value.ruleCondition.length)
const isUpdate = computed(() => !!formModel.value.ruleId)

const onFormRuleAdd = () => {
  if (ruleCounts.value >= 10) return
  formModel.value.ruleCondition.push(getConditionFields())
  nextTick(() => {
    const els = document.querySelectorAll('.rules-list .index-text')
    const [lastEl] = Array.from(els).slice(-1) || []
    lastEl?.scrollIntoView({ behavior: 'smooth', block: 'end' })
  })
}
const onFormRuleRemove = (_index) => {
  formModel.value.ruleCondition = formModel.value.ruleCondition.filter((_, index) => _index !== index)
}
// eslint-disable-next-line
defineExpose({
  validate: () => formRef.value.validate(),
  getFormModel: () => formModel.value,
  setFormModel: (form) => {
    let rules = []
    const { ruleCondition, id, gameGroupId, platform, mediaId } = form
    try {
      rules = JSON.parse(ruleCondition)
    } catch (e) {
      console.log('parse ruleCondition error output: ', e)
    }
    formModel.value = {
      ruleId: id,
      gameGroupId: gameGroupId,
      platform: platform,
      mediaId: mediaId,
      ruleCondition: rules?.length ? rules : [getConditionFields()]
    }
  }
})
</script>

<style lang="scss" scoped>
.rules-list {
  max-height: 170px;
  overflow: auto;
}
.rule-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .index-text {
    font-size: 12px;
    color: #aaa;
    width: 16px;
    text-align: right;
    margin-right: 4px;
    text-align: center;
  }

  .selector {
    width: 150px;
    margin-right: 5px;
    &:nth-child(3) {
      width: 110px;
    }
  }

  .input {
    flex: 1;
    min-width: 50px;
  }

  .close {
    cursor: pointer;
    padding: 0 5px;
  }
}
</style>
